import { LanguagesService } from '@alpha-core/platform-ui';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PrimeNGModules } from '../../shared/alpha-shared.module';

@Component({
    selector: 'app-dialog',
    standalone: true,
    imports: [PrimeNGModules, FormsModule, TranslatePipe],
    templateUrl: './dialog.component.html',
})
export class DialogComponent {
    private dialogRef = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    private messageService = inject(MessageService);

    languagesService = inject(LanguagesService);
    skillData!: { skillName: string; rating: number | null };

    cancel(event: MouseEvent) {
        event.stopPropagation();
        this.dialogRef.close(false);
    }

    ngOnInit() {
        this.skillData = this.config.data?.skill ?? { skillName: '', rating: null };
    }

    addNewSkill() {
        const trimValue = this.skillData.skillName.trim();
        const rating = this.skillData.rating;
        if (trimValue == '' || !rating) {
            this.messageService.add({
                severity: 'warn',
                detail: `Please ensure to add a valid value before submitting the form`,
                summary: 'Add valid value',
            });
            return;
        }

        if (trimValue.length > 255) {
            const curName =
                this.languagesService.translateConfig('{{lang.default-character-exceed}}') ||
                'Cannot exceed 255 characters';
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid length',
                detail: curName,
            });
            return;
        }

        this.dialogRef.close(this.skillData);
    }

    submitForm(event: any) {
        this.dialogRef.close(true);
    }

    get skillName() {
        return this.skillData.skillName;
    }
}
